"use strict";
import { tns } from "tiny-slider";

export default function () {
    const valid = document.querySelector(".content-menu__list");
    if (valid) {
        const slider = tns({
            container: ".content-menu__list",
            slideBy: 1,
            controls: false,
            nav: false,
            loop: false,
            touch: true,
            mouseDrag: true,
            items: 2,
            responsive: {
                1024: {
                    items: 5.5,
                },
            },
        });

        const arrowLeft = document.querySelector(".content-menu .arrows-left");
        arrowLeft.addEventListener("click", () => {
            slider.goTo("prev");
        });
        const arrowRight = document.querySelector(
            ".content-menu .arrows-right"
        );
        arrowRight.addEventListener("click", () => {
            slider.goTo("next");
        });
    }
}
